export default {
  confirmationTitle: 'Please confirm',
  confirmationContent: 'Are you sure you want to continue?',
};
